export default __webpack_public_path__ + "static/media/linkedingLogo.20986eb9.svg";